module.exports = __webpack_public_path__ + "static/handle_failure.ca3fa4d2.png";